import { AutoComplete, Button, Col, Divider, Form, Input, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../../../context/AuthProvider';
import {
  setPmContractProject,
  updateEquipmentTab,
  updateField,
} from '../../../../../contextRedux/PMContractProject/PmContractModelProject';
import { RootState } from '../../../../../store';
import './CompanyDetailsTab.css';

const { Option } = AutoComplete;

interface CompanyDetailsTabProps {
  form: any;
}

const CompanyDetailsTab: React.FC<CompanyDetailsTabProps> = ({ form }) => {
  const dispatch = useDispatch();
  const id = useSelector((state: RootState) => state?.models?.pmContractProject?.id);
  const companyId = useSelector((state: RootState) => state?.models?.pmContractProject?.companyId);

  //initialize from parrent NewOffer
  const companies = useSelector((state: RootState) => state.store.company.data);
  const pmContractProjectStatuses = useSelector((state: RootState) => state?.store.pmContractProjectStatus.data);
  const pmOfferContractTypes = useSelector((state: RootState) => state?.store.pmOfferContractType.data);
  const users = useSelector((state: RootState) => state?.store.user.data);
  const pmContractProject = useSelector((state: RootState) => state?.models.pmContractProject);
  const pmOffers = useSelector((state: RootState) => state.store.pmOffer.data);

  const [currentTotal, setCurrentTotal] = useState(0);
  const currentDate = moment().format('YYYY-MM-DD');
  const { profile } = useAuth();

  const initialValues = {
    company: useSelector((state: RootState) => state?.models?.pmContractProject?.company),
    companyId: useSelector((state: RootState) => state?.models?.pmContractProject?.companyId),
    accountManager: useSelector((state: RootState) => state?.models?.pmContractProject?.accountManager),
    projectAuthor: useSelector((state: RootState) => state?.models?.pmContractProject?.projectAuthor),
    projectAuthorId: useSelector((state: RootState) => state?.models?.pmContractProject?.projectAuthorId),
    chiefTechnicianId: useSelector((state: RootState) => state?.models?.pmContractProject?.chiefTechnicianId),
    enumPmOfferContractTypeId: useSelector(
      (state: RootState) => state?.models?.pmContractProject?.enumPmOfferContractTypeId
    ),
    enumPmOfferContractType: useSelector(
      (state: RootState) => state?.models?.pmContractProject?.enumPmOfferContractType
    ),
    enumPmContractProjectStatusId: useSelector(
      (state: RootState) => state?.models?.pmContractProject?.enumPmContractProjectStatusId
    ),
    enumPmContractProjectStatus: useSelector(
      (state: RootState) => state?.models?.pmContractProject?.enumPmContractProjectStatus
    ),
    date: useSelector((state: RootState) => state?.models?.pmContractProject?.date),
    dateStart: useSelector((state: RootState) => state?.models?.pmContractProject?.dateStart),
    dateEnd: useSelector((state: RootState) => state?.models?.pmContractProject?.dateEnd),
    remarks: useSelector((state: RootState) => state?.models?.pmContractProject?.remarks),
    registrationNumber: useSelector((state: RootState) => state?.models?.pmContractProject?.registrationNumber),
    pmContractIntervals: useSelector((state: RootState) => state?.models?.pmContractProject?.pmContractIntervals),
    totalOfferValue:
      Number.parseFloat(
        (
          pmContractProject.pmContractWorkPlaceItems.reduce((total, item) => total + item.laborPrice, 0) +
          (pmContractProject.pmContractLaborExtras
            ? pmContractProject.pmContractLaborExtras.reduce(
                (total: any, item: any) => total + item?.piece * item?.price,
                0
              )
            : 0)
        ).toFixed(2)
      ) +
      Number.parseFloat(
        pmContractProject.pmContractWorkPlaceItems.reduce((total, item) => {
          const totalPrice = item.price;
          return total + totalPrice;
        }, 0)
      ),
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  const handleSelectClient = (value: any) => {
    const company = companies.find((company: any) => company.name === value?.label);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      company: company,
      companyId: company?.id,
      accountManager: company?.accountManager,
    };

    form.setFieldsValue(fieldsValue);

    dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
    dispatch(updateField({ field: 'company', value: company ?? null }));

    dispatch(updateField({ field: 'accountManagerId', value: company?.accountManager?.id ?? null }));
    dispatch(updateField({ field: 'accountManager', value: company?.accountManager ?? null }));
  };

  const handleSelectProjectAuthor = (value: string) => {
    const projectAuthor = users?.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      projectAuthor: projectAuthor,
      projectAuthorId: projectAuthor?.id,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'projectAuthorId', value: projectAuthor?.id ?? null }));
    dispatch(updateField({ field: 'projectAuthor', value: projectAuthor ?? null }));
  };

  const handleSelectStatus = (value: string) => {
    const selectStatus = pmContractProjectStatuses.find((date) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumPmContractProjectStatusId: selectStatus?.id,
      enumPmContractProjectStatus: selectStatus,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumPmContractProjectStatusId', value: selectStatus?.id ?? null }));
    dispatch(updateField({ field: 'enumPmContractProjectStatus', value: selectStatus ?? null }));
  };

  const handleSelectType = (value: string) => {
    const selectedType = pmOfferContractTypes?.filter((pc) => [2].includes(pc.id)).find((type) => type.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumPmOfferContractTypeId: selectedType?.id,
      enumPmOfferContractType: selectedType,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumPmOfferContractTypeId', value: selectedType?.id ?? null }));
    dispatch(updateField({ field: 'enumPmOfferContractType', value: selectedType ?? null }));
  };

  const handleSelectClientOffer = (value: string) => {
    const pmOffer = pmOffers.find((o) => o?.number == value);

    // Map pmOfferWorkPlaceItems to pmContractWorkPlaceItems format
    const mappedWorkPlaceItems = pmOffer.pmOfferWorkPlaceItems.map((item: any) => {
      return {
        // Keep null ID for new contract items
        id: null,
        // Map fields that need to be renamed
        pmContractWorkPlaceId: null, // This will be assigned later
        deviceTypeId: item.deviceTypeId,
        systemTypeId: item.systemTypeId,
        workPlaceId: item.workPlaceId,
        agentId: item.agentId,
        chiefTehnicianId: item.chiefTehnicianId,
        // Copy direct field mappings
        price: item.price,
        addition: item.addition,
        piece: item.piece,
        laborPrice: item.laborPrice,
        laborTime: item.laborTime,
        unitMeasure: item.unitMeasure,
        details: item.details,
        isAnotherProvider: item.isAnotherProvider,
        // Map metadata and nested objects
        metadata: item.metadata,
        // Map technicians if they exist
        pmContractWorkPlaceItemTehnicians:
          item.pmOfferWorkPlaceItemTehnicians?.map((tech: any) => ({
            id: null,
            pmContractWorkPlaceItemId: null, // Will be assigned later
            userId: tech.userId,
            user: tech.user,
          })) || [],
        // Map stage if it exists
        pmContractWorkPlaceItemStage: item.pmOfferWorkPlaceItemStage
          ? {
              id: null,
              name: item.pmOfferWorkPlaceItemStage.name,
              dateStart: item.pmOfferWorkPlaceItemStage.dateStart,
              pmContractWorkPlaceItemId: null, // Will be assigned later
            }
          : null,
        // Include other necessary objects
        systemType: item.systemType,
        device: item.device,
        agent: item.agent,
        workPlace: item.workPlace,
        chiefTehnician: item.chiefTehnician,
        // Map contractWorkPlaceMetadata from pmOfferWorkPlaceMetadata
        contractWorkPlaceMetadata: {
          agent: item.pmOfferWorkPlaceMetadata?.agent || null,
          workPlace: item.pmOfferWorkPlaceMetadata?.workPlace || null,
        },
      };
    });

    dispatch(
      setPmContractProject({
        ...pmOffer,
        id: null,
        pmOfferId: pmOffer?.id,
        pmContractLaborExtras: pmOffer.pmOfferLaborExtras,
        pmContractWorkPlaceItems: mappedWorkPlaceItems,
        pmContractIntervals: pmOffer.pmOfferIntervals,
        pmContractSectionFiles: pmOffer.pmOfferSectionFiles,
        enumPmContractProjectStatusId: 1,
        enumPmContractProjectStatus: { id: 1, name: 'On Hold' },
      })
    );

    const pmOfferCompany = companies.find((c) => c.id == pmOffer.companyId);
    dispatch(updateField({ field: 'company', value: pmOfferCompany }));
    dispatch(updateField({ field: 'companyId', value: pmOfferCompany?.id }));

    dispatch(updateEquipmentTab({ field: 'isOfferSelected', value: true }));
  };

  const onDateChange = (dateField: string, dateValue: string) => {
    dispatch(updateField({ field: dateField, value: dateValue }));
    form.setFieldsValue({ [dateField]: dateValue });
  };

  const handleBlurClear = (fieldNames: string[]) => {
    fieldNames.forEach((field) => {
      form.setFieldsValue({ [field]: null });
      dispatch(updateField({ field, value: null }));
    });
  };

  const handlePriceChange = (value: number, index: number) => {
    const intervals = [...(pmContractProject.pmContractIntervals || [])];
    intervals[index] = { ...intervals[index], price: value };
    calculateTotal(intervals);
  };

  const getCurrentIntervalPrice = () => {
    const total = form
      ?.getFieldValue('pmContractIntervals')
      ?.reduce((acc: number, cur: any) => acc + Number(cur?.price ?? 0), 0);
    return total ?? 0;
  };

  const handleRemove = (remove: Function, name: number) => {
    remove(name);
    const intervals = [...(form?.getFieldValue('pmContractIntervals') || [])];
    intervals.splice(name, 1); // Remove the interval from the array
    calculateTotal(intervals);
  };

  const calculateTotal = (intervals: any[]) => {
    const total = (intervals || []).reduce((sum, interval) => sum + Number(interval?.price || 0), 0);
    setCurrentTotal(total);
  };

  const handleAddInterval = (add: Function) => {
    add();
  };

  useEffect(() => {
    form?.setFieldValue('pmContractIntervals', pmContractProject.pmContractIntervals);
  }, []);

  useEffect(() => {
    if (companyId) {
      const company = companies.find((company: any) => company.id === companyId);
      form.setFieldsValue({
        company: { name: company?.name },
        companyId: company?.id,
        accountManager: company?.accountManager,
      });
      dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
      dispatch(updateField({ field: 'company', value: company ?? null }));
      form.setFieldsValue({
        ...initialValues,
      });
      if ((id == null || id == undefined || id == '') && !!profile?.name) {
        handleSelectProjectAuthor(profile?.name!);
      }
    }
  }, [companyId]);

  useEffect(() => {
    if (id == null || id == undefined || id == '') {
      const currentDate = new Date().toISOString().split('T')[0];
      const oneYearLater = new Date();
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split('T')[0];

      form.setFieldsValue({
        ...initialValues,
      });

      dispatch(updateField({ field: 'enumPmContractProjectStatusId', value: 2 }));
      dispatch(updateField({ field: 'enumPmContractProjectStatus', value: { id: 2, name: 'Draft' } }));
      dispatch(updateField({ field: 'enumPmOfferContractTypeId', value: 2 }));
      dispatch(updateField({ field: 'date', value: currentDate }));
      dispatch(updateField({ field: 'dateStart', value: currentDate }));
      dispatch(updateField({ field: 'dateEnd', value: formattedOneYearLater }));
    }
  }, [id]);

  const remainingValue = initialValues.totalOfferValue - currentTotal;

  return (
    <Form form={form} onValuesChange={handleFieldChange} layout='vertical' className='form-container'>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['company', 'name']}
            label='Selectati Client'
            rules={[{ required: true, message: 'Alegeti un client!' }]}
          >
            <Select
              disabled={!!id}
              showSearch // Enables search functionality
              placeholder='Search and select a client'
              optionFilterProp='label'
              onSelect={(_value, option: any) => {
                handleSelectClient(option);
              }}
              onChange={() => handleBlurClear(['company', 'companyId'])} // Clear form fields when changed
              filterOption={(input, option) => {
                return option?.label?.toLowerCase()?.includes(input.toLowerCase());
              }}
              options={companies?.map((company) => ({
                value: company?.id,
                label: company?.name,
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountManager', 'name']}
            label='Manager de cont'
            rules={[{ required: true, message: 'Alegeti un manager de cont!' }]}
          >
            <Input disabled={true} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['projectAuthor', 'name']}
            label='Autor proiect'
            rules={[{ required: true, message: 'Alegeti un autor de proiect!' }]}
          >
            <AutoComplete
              options={users?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectProjectAuthor}
              onChange={() => handleBlurClear(['projectAuthor', 'projectAuthorId'])}
              filterOption={(input, option: any) => option.value.toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        </Col>
        {(id == '' || id == undefined || id == null) && (
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item name={['offer', 'number']} label='Select Offer'>
              <AutoComplete onSelect={handleSelectClientOffer}>
                {pmOffers?.map((offer: any, index: any) => (
                  <Option key={index} value={offer?.number}>
                    {offer?.number}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>
        )}
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['enumPmContractProjectStatus', 'name']}
            label='Status'
            rules={[{ required: true, message: 'Alegeti un status!' }]}
          >
            <AutoComplete
              options={pmContractProjectStatuses?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectStatus}
              onChange={() => handleBlurClear(['enumPmContractProjectStatus', 'enumPmContractProjectStatusId'])}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['enumPmOfferContractType', 'name']}
            label='Tip contract'
            rules={[{ required: true, message: 'Alegeti un tip oferta!' }]}
          >
            <AutoComplete
              options={pmOfferContractTypes
                ?.filter((pc) => [2].includes(pc.id))
                ?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectType}
              onChange={() => handleBlurClear(['enumPmOfferContractType', 'enumPmOfferContractTypeId'])}
            />
          </Form.Item>
        </Col>
        <Divider />
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Contract'
            name='date'
            rules={[{ required: true, message: 'Introduceti data contract!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('date', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Inceput'
            name='dateStart'
            rules={[{ required: true, message: 'Introduceti data inceput!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateStart', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Sfarsit'
            name='dateEnd'
            rules={[{ required: true, message: 'Introduceti data sfarsit!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateEnd', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Numar de Inregistrare'
            name='registrationNumber'
            rules={[{ required: true, message: 'Introduceti numarul de inregistrare!' }]}
          >
            <Input onChange={(e) => dispatch(updateField({ field: 'registrationNumber', value: e.target.value }))} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label='Obervatii' name='remarks'>
            <TextArea />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Form.List name='pmContractIntervals'>
        {(fields, { add, remove }) => (
          <>
            {fields?.map(({ key, name, ...restField }, index) => (
              <Row key={key} gutter={16} align='middle'>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    {...restField}
                    label='Data'
                    name={[name, 'date']}
                    rules={[{ required: true, message: 'Introduceti data!' }]}
                  >
                    <Input type='date' />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    {...restField}
                    label='Valoare'
                    name={[name, 'price']}
                    rules={[
                      { required: true, message: 'Introduceti pretul!' },
                      () => ({
                        validator(_, _value) {
                          const currentPrice = getCurrentIntervalPrice();
                          if (currentPrice <= initialValues.totalOfferValue) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(`Valoarea totală nu poate depăși ${initialValues.totalOfferValue}`)
                          );
                        },
                      }),
                    ]}
                  >
                    <Input
                      type='number'
                      min={0}
                      max={remainingValue + Number(getCurrentIntervalPrice())}
                      onChange={(e) => handlePriceChange(Number(e.target.value), index)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Button danger onClick={() => handleRemove(remove, name)} className='CompaniDetails-del'>
                    Sterge
                  </Button>
                </Col>
              </Row>
            ))}
            <Form.Item>
              <Button
                type='dashed'
                onClick={() => handleAddInterval(add)}
                block
                disabled={!(getCurrentIntervalPrice() <= initialValues.totalOfferValue)} // Disable if total equals or exceeds totalOfferValue
                style={{ marginTop: 10 }}
              >
                Adauga Incasare
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default CompanyDetailsTab;
